export default __webpack_public_path__ + "static/media/aa-coporation-logov-v2.e2a94e12.png";